import React from "react";
export const VSettings = () => {
  return (
    <div className='text-black'>Vsettings</div>
  );
};
